import {
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAIL,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAIL,
  RESET_PROFILE_STATE,
  UPDATE_USER_PWD_SUCCESS,
  UPDATE_USER_PWD_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  profile: [],
  editProfile: [],
  editUserPwd: [],
}

const User = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      }

    case GET_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        editProfile: action.payload,
        profile: action.payload.data,
      }

    case UPDATE_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_USER_PWD_SUCCESS:
      return {
        ...state,
        editUserPwd: action.payload,
      }

    case UPDATE_USER_PWD_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case RESET_PROFILE_STATE:
      return {
        ...state,
        editProfile: [],
        editUserPwd: [],
      }
    default:
      return state
  }
}

export default User
